import { useState } from "react";

export default function usePlannerFilters() {
  const [searchTerm, setSearchTerm] = useState("");
  const [staffPoolTab, setStaffPoolTab] = useState("ready");
  const [lifecycleFilter, setLifecycleFilter] = useState("");
  const [mobileBoardRole, setMobileBoardRole] = useState("");

  return {
    searchTerm,
    setSearchTerm,
    staffPoolTab,
    setStaffPoolTab,
    lifecycleFilter,
    setLifecycleFilter,
    mobileBoardRole,
    setMobileBoardRole,
  };
}